// extracted by mini-css-extract-plugin
export default {"closeIcon":"ViV8pE","container":"OxG2HB","containerUx4":"uuPoAm","containerShow":"SFFaTR","bsAnimationShow":"qwqTuW","containerHide":"BokLM4","bsAnimationClose":"GsfysW"};